import { FunctionComponent } from 'react';
import ALink from '@xFrame4/components/next/ALink';

export interface SocialMediaLinksProps
{
    facebook?: string | null;
    instagram?: string | null;
    linkedin?: string | null;
    youtube?: string | null;
    tiktok?: string | null;
    className?: string;
    iconClassName?: string;
    linkClassName?: string;
}

/**
 * Component: renders social media links with icons if the URLs are provided and not empty.
 */
const SocialMediaLinks: FunctionComponent<SocialMediaLinksProps> = (props) =>
{
    /** Check if a URL is valid (not null, undefined, or empty string) */
    const isValidUrl = (url?: string | null): boolean =>
    {
        return url != null && url.trim() !== '';
    }

    /** Get the social media links that have valid URLs */
    const socialMediaItems = [
        {
            url: props.facebook,
            icon: 'fab fa-facebook-f',
            platform: 'Facebook'
        },
        {
            url: props.instagram,
            icon: 'fab fa-instagram',
            platform: 'Instagram'
        },
        {
            url: props.linkedin,
            icon: 'fab fa-linkedin-in',
            platform: 'LinkedIn'
        },
        {
            url: props.youtube,
            icon: 'fab fa-youtube',
            platform: 'YouTube'
        },
        {
            url: props.tiktok,
            icon: 'fab fa-tiktok',
            platform: 'TikTok'
        }
    ].filter(item => isValidUrl(item.url));

    /** Don't render anything if no valid social media links */
    if (socialMediaItems.length === 0)
    {
        return null;
    }

    /** Render */
    return (
        <div className={`social-media-links ${props.className ?? ''}`}>
            <div className="d-flex gap-3">
                {socialMediaItems.map((item, index) => (
                    <ALink 
                        key={index}
                        href={item.url!}
                        className={props.linkClassName || 'text-decoration-none'}
                        target="_blank"
                    >
                        <i className={`${item.icon} ${props.iconClassName ?? ''}`}></i>
                    </ALink>
                ))}
            </div>
        </div>
    );
}

export default SocialMediaLinks; 